export default __webpack_public_path__ + "static/media/f0021-01.59c66453.png";